import { featureItems } from "@/mocks/home";

export default function Highlights() {
  return (
    <section id="features" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
          <div className="lg:sticky lg:top-24 lg:self-start">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              同门电影 · 看点
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              同门电影里容易被忽略的五处细节
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              同门题材看起来热闹，真正撑起它的却是关系、节奏与配角这些不起眼的地方。下面这五点，可以作为观看时的一条线索。
            </p>
            <div className="mt-8 hidden h-56 w-full overflow-hidden rounded-lg border border-background-200/70 lg:block">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20cinematic%20detail%20of%20wooden%20practice%20weapons%20and%20old%20scrolls%20on%20a%20table%20in%20soft%20amber%20light%2C%20quiet%20disciplined%20mood%2C%20stylized%20art%2C%20no%20people%2C%20rich%20brown%20tones&width=900&height=700&seq=master-feature-09&orientation=landscape"
                alt="木制练武器与旧卷轴在暖光下的静物示意图"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>

          <ol className="space-y-3">
            {featureItems.map((item) => (
              <li
                key={item.no}
                className="flex items-start gap-4 rounded-lg border border-background-200/70 bg-background-100 p-5 transition-colors hover:border-accent-400"
              >
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-accent-500 font-heading text-base font-black text-foreground-950">
                  {item.no}
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}